import React from 'react';

/**
 * These settings are passed down from the host app, derived from the user session's site and user settings.
 */
export type UserAndSiteSettings = {
  /** Whether or not users are visible, based on site setting and user role */
  readonly areUsersVisible: boolean;
};

export const UserAndSiteSettingsContext = React.createContext<UserAndSiteSettings>(null as unknown as UserAndSiteSettings);
